import { fromStateNameToCode } from "../../helpers/stateHelpers";
import { normalizeAddressState } from "../form_fields/addressNormalizer";

// Fields that contain state values and need normalization
const STATE_FIELDS = new Set([
  "stateRegistration",
  "stateForeign",
  "stateAnnualReports",
  "foreignStateRegistration",
]);

export const populateBusinessFromFiling = (
  filing,
  field,
  defaultValue = null,
  schemaKey = "Tax_Basics"
) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";
  const fieldData = taxDetails?.BTF?.[dataPath]?.[field];
  
  // If fieldData is an object with a value property (single_boolean_choice format)
  if (fieldData && typeof fieldData === "object" && "value" in fieldData) {
    return { value: fieldData.value };
  }
  
  // No data found
  return { value: defaultValue };
};

export const populateBusinessSimpleDataFromFiling = (
  filing,
  field,
  defaultValue = false,
  schemaKey
) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";
  let value = taxDetails?.BTF?.[dataPath]?.[field] || defaultValue;

  if (STATE_FIELDS.has(field) && value) {
    value = fromStateNameToCode(value);
  }

  return value;
};

export const populateBusinessMultiAddressFromFiling = (
  filing,
  field,
  schemaKey
) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";
  const addresses = taxDetails?.BTF?.[dataPath]?.[field] || [];

  if (Array.isArray(addresses)) {
    return addresses.map(normalizeAddressState);
  }

  return addresses;
};

export const populateBusinessSingleAddressFromFiling = (
  filing,
  field,
  schemaKey
) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";

  let address = taxDetails?.BTF?.[dataPath]?.[field] || null;

  // If no grouped object, try to construct from individual fields
  if (!address && field === "businessAddress") {
    const pathData = taxDetails?.BTF?.[dataPath];
    if (pathData) {
      const addressFields = [
        "city",
        "address",
        "zipCode",
        "stateAddress",
        "suiteAddress",
        "country",
      ];
      const hasIndividualFields = addressFields.some((f) =>
        Object.prototype.hasOwnProperty.call(pathData, f)
      );

      if (hasIndividualFields) {
        const normalizedStateAddress = fromStateNameToCode(pathData.stateAddress) || pathData.stateAddress || "";
        address = {
          city: pathData.city || "",
          address: pathData.address || "",
          zipCode: pathData.zipCode || "",
          stateAddress: normalizedStateAddress,
          suiteAddress: pathData.suiteAddress || "",
          country: pathData.country || "US",
        };
      }
    }
  }

  // Remove fromDate and toDate if they exist (single addresses don't have dates)
  if (address && typeof address === "object") {
    const { fromDate, toDate, ...addressWithoutDates } = address;
    return normalizeAddressState(addressWithoutDates);
  }

  return address;
};
